import CryptoJS from "crypto-js";

export const encrypt = (value) => {
  return CryptoJS.AES.encrypt(value, process.env.REACT_APP_URL_CRYPTO_KEY).toString();
};

export const decrypt = (ciphertext) => {
  return CryptoJS.AES.decrypt(ciphertext, process.env.REACT_APP_URL_CRYPTO_KEY).toString(CryptoJS.enc.Utf8);
};
